import React from 'react';

const EmotionDataContext = React.createContext(null);

export default EmotionDataContext;
